<template>
  <px-lateral-dialog :width="width"
                     v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Atualizar moeda
    </template>
    <template>
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <v-row dense>
        <v-col cols="12">
          Carregamos o valor do PTAX atual no campo abaixo.
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <px-input-currency
            dense
            :label="`Valor do ${compra.moeda}`"
            class="required rounded-tag-small"
            ref="precoUnitario"
            v-model="valorMoeda"
            :options="configuracaoMoeda"
            :precision="4"
            :error="$v.valorMoeda.$error"
            @blur="$v.valorMoeda.$touch()"/>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn class="normal-btn-text rounded-tag-small elevation-0"
             @click="close">
        Cancelar
      </v-btn>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :loading="loadingAtualizacao"
             @click="onClickAtualizar">
        Atualizar
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import moedaMixin from '@/mixins/moeda-mixin';
import validationMixin from '@/mixins/validation-mixin';
import ValorMoedaService from '@/api/valor-moeda-service';
import CompraService from '@/modules/compra/compra-service';

export default {
  mixins: [moedaMixin, validationMixin],
  props: {
    width: {
      type: Number,
      default: 400,
    },
    compra: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loadingAtualizacao: false,
      valorMoeda: null,
    };
  },
  computed: {
    moeda() {
      return this.compra.moeda;
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    onClickAtualizar() {
      if (this.validateForm()) {
        return;
      }
      this.loadingAtualizacao = true;
      const payload = {
        valor: this.valorMoeda,
      };
      CompraService.atualizarValorMoeda(this.compra.id, payload)
        .then(() => {
          this.$toast('Valores da compra atualizados', { color: 'success' });
          this.$emit('change');
          this.close();
        })
        .finally(() => {
          this.loadingAtualizacao = false;
        });
    },
    getValorMoeda() {
      this.loading = true;
      ValorMoedaService.getValorMoeda(this.moeda)
        .then(({ data }) => {
          if (!data.valorMoeda) {
            return;
          }
          this.valorMoeda = data.valorMoeda.taxaVenda;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue || !newValue) {
        return;
      }
      this.getValorMoeda();
    },
  },
  validations: {
    valorMoeda: {
      required,
      minValue(value) {
        return value > 0;
      },
    },
  },
};
</script>
